export const makeQueryResultSubscriptionHook = <T extends (...args: any) => any>(
  _query: T,
): ((...args: Parameters<T>) => ReturnType<T>) => {
  const query: (...args: Parameters<T>) => ReturnType<T> = (...args: Parameters<T>) => {
    const result = _query({
      initialFetchPolicy: 'cache-only',
      fetchPolicy: 'cache-only',
      ...args[0],
    }) as ReturnType<T>;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result;
  };

  return query;
};
